import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class Footer extends React.Component {
  render() {
    return (
      <div className={classNames("card round-big shadow mt-5", this.props.className)}>
        <div className="card-body">
          <div className="row">
            <div className="col-md-2 col-sm-4">
              <img className="w-100" src={this.props.image1} />
            </div>
            <div className="col-md-2 col-sm-4">
              <img className="w-100" src={this.props.image2} />
            </div>
            <div className="col-md-2 col-sm-4">
              <img className="w-100" src={this.props.image3} />
            </div>
            <div className="col-md-6 col-sm-12 pt-3">
              <div className="row">
                <div className="col-12 col-md-3 text-center p-0">© FirstCare Ltd</div>
                <div className="col-12 col-md-4 text-center p-0">All Rights Reserved</div>
                <div className="col-6 col-md-2 text-center p-0">
                  <a href={this.props.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
                    {this.props.privacyPolicyText}
                  </a>
                </div>
                <div className="col-6 col-md-3 text-center p-0">
                  <a href={this.props.aboutUsUrl} target="_blank" rel="noopener noreferrer">
                    {this.props.aboutUsText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Footer.propTypes = {
  image1: PropTypes.string,
  image2: PropTypes.string,
  image3: PropTypes.string,
  aboutUsText: PropTypes.string,
  aboutUsUrl: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.object,
  ]),
  privacyPolicyText: PropTypes.string,
  privacyPolicyUrl: PropTypes.string,
};

Footer.defaultProps = {
  aboutUsText: "About Us",
  aboutUsUrl: "https://www.firstcare.eu/about-us/",
  privacyPolicyText: "Privacy",
  privacyPolicyUrl: "https://www.firstcare.uk/fairprocessing",
};

export default Footer;
